import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./portfoliogallery.css";


const PortfolioGallery = () => {
    const { portfolioCategory } = useParams();
  
    const texts = {
      brandcontent: {
        title: "Brand & Product Content",
        description: "A gallery of visuals created for campaigns, product launches and collaborations. This collection includes content tailored for social media, e-commerce and editorial use, with a focus on my creative vision, styling and understanding of brand identity."
      },
      fashion: {
        title: "Fashion",
        description: "This space gathers my personal way of wearing clothes and expressing myself through fashion. Every look reflects a mood, a detail or a moment that speaks about who I am."
      },
      myaesthetic: {
        title: "My Aesthetic",
        description: "A gallery of visuals created for my own pleasure, bringing my view to life."
      },
      selfcaremakeup: {
          title: "Selfcare & Makeup",
          description: "Here you will find numerous makeup looks and how I take care of my skin. Also, here you will find the courage I have to change my hair at home."
      }
    };

    const pageText = texts[portfolioCategory] || {
        title: portfolioCategory,
        //description: `A gallery around ${portfolioCategory}.`
      };
 
    const [mediaItems, setMediaItems] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {

        fetch(`https://iulianamihai.com/api/cloudinary/portfolio/${portfolioCategory}`)
          .then(res => res.json())
          .then(data => {
    
            const items = data.map(file => {
              const name = file.public_id
                .split("/")
                .pop()
                .replace(/_[a-z0-9]+$/, "")
                .replace(/[-_]/g, " ") + ".";
    
              return {
                type: file.resource_type,      // image sau video
                src: file.secure_url,
                alt: name,
                poster: file.context?.alt || null
              };
    
            });
            setMediaItems(items);
          })
          .catch(err => console.log("API error:", err));
    
        }, [portfolioCategory]);

        console.log("CATEGORY:", portfolioCategory);
    
      const handleClick = (index) => { setActiveIndex(index);};
      const closeLightbox = () => { setActiveIndex(null);};
      const showPrev = () => { setActiveIndex(prev =>prev > 0 ? prev - 1 : mediaItems.length - 1);};
      const showNext = () => { setActiveIndex(prev => prev < mediaItems.length - 1 ? prev + 1 : 0 );};

      return (
        <div className="containerPortfolioGallery">
          <div className="titleandtextPortfolioGallery">
            <h1 className="titlePortfolioGallery">{pageText.title}</h1>
            <span className="textPortfolioGallery">
              <div style={{ whiteSpace: "pre-line" }}>
                {pageText.description}
              </div>
              <br /> → Tap any image to view it in full size. Use the arrows to navigate left and right.
            </span>
          </div>

          <div className="gridPortfolioGallery">
            {mediaItems.map((item, index) => (
              <div key={index} className="thumbPortfolioGallery" onClick={() => handleClick(index)} >
                {item.type === "video" ? (
                  <video src={item.src} poster={item.poster || ""} muted playsInline preload="metadata" />
                ) : ( <img src={item.src} alt={item.alt} />
                )}
              </div>
            ))}
          </div> {activeIndex !== null && (
            <div className="lightboxPortfolioGallery" onClick={closeLightbox}>
              <button className="nav prev" onClick={(e) => { e.stopPropagation(); showPrev();}}>‹ </button>
              <div className="lightboxContentPortfolioGallery" onClick={(e) => e.stopPropagation()}>
                {mediaItems[activeIndex].type === "video" ? (
                  <video src={mediaItems[activeIndex].src} poster={mediaItems[activeIndex].poster || ""} controls autoPlay /> 
                ) : (<img src={mediaItems[activeIndex].src} alt={mediaItems[activeIndex].alt}/>)}
                <p className="lightboxCaptionPortfolioGallery"> {mediaItems[activeIndex].alt} </p>
              </div>
              <button className="nav next" onClick={(e) => { e.stopPropagation(); showNext();}}>› </button>
              <button className="close" onClick={(e) => { e.stopPropagation(); closeLightbox(); }}>×</button>
            </div>
          )}
        </div>
      );
    };
    
    export default PortfolioGallery;

